import { Pressable } from 'components/ui';
import React, { useState } from 'react';
import styled from '@emotion/styled';
import { theme } from 'theme/theme';

const Wrapper = styled('div')`
  display: flex;
  background-color: ${(p) =>
    p.isHovered ? p.colors.muted['200'] : 'transparent'};
  border-radius: 3px;
  margin-left: 4px;
  padding: 4px;
  transition: background-color 350ms linear;
`;

export const IconButton = ({ children, onClick }) => {
  const { colors } = theme;
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Pressable
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Wrapper colors={colors} isHovered={isHovered}>
        {children}
      </Wrapper>
    </Pressable>
  );
};
